// extracted by mini-css-extract-plugin
export default {"container":"zC-z","dimension":"AC-z","dimensionLabels":"BC-z"};